import { makeStyles } from "tss-react/mui"
import { useDateTime } from "../../../../../../localization/useDateTime"
import { MeetingDetailsOrder } from "../../../../../../nonAdminUser/reports/home/meetingServiceApi"
import { DeliveryType, getDeliveryTypeValue } from "../../meetingServiceTypes"
import DetailRow from "./DetailRow"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Stack } from "@mui/system"
import { useMemo } from "react"

const useStyles = makeStyles()((theme) => ({
    sectionTitle: {
        fontWeight: 600,
        color: theme.palette.tailwind.slate[900],
        marginBottom: theme.spacing(2),
    },
    deliveryDetailsContainer: {
        marginTop: theme.spacing(2),
    },
}))

interface DeliveryDetailsProps {
    order: MeetingDetailsOrder
}

export default function DeliveryDetails({ order }: DeliveryDetailsProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const meetingTimeStart = dateTimeFactory.fromApi(order.meetingDetails?.startDateTime)
    const meetingTimeEnd = dateTimeFactory.fromApi(order.meetingDetails?.endDateTime)

    const deliveryLocation = useMemo(() => {
        const deliveryTypeValue = getDeliveryTypeValue(order.deliveryDetails.type)

        // For "Eating in canteen" and "Picked up", show delivery type
        if (deliveryTypeValue === DeliveryType.EATING_IN_CANTEEN || deliveryTypeValue === DeliveryType.PICKED_UP) {
            return deliveryTypeValue
        }

        return order.deliveryDetails.location?.name ?? "-"
    }, [order])

    return (
        <Stack gap="0.5rem" className={classes.deliveryDetailsContainer}>
            <LocalizedStrict id="production-package-slip-section-delivery-details-meeting-time" attrs={{ label: true }}>
                <DetailRow
                    label="Meeting time:"
                    value={
                        meetingTimeStart.isValid && meetingTimeEnd.isValid
                            ? dateTimeFactory.formatPeriod(meetingTimeStart, meetingTimeEnd)
                            : "-"
                    }
                />
            </LocalizedStrict>
            <LocalizedStrict id="production-package-slip-section-delivery-details-location" attrs={{ label: true }}>
                <DetailRow label="Delivery location:" value={deliveryLocation} />
            </LocalizedStrict>
            <LocalizedStrict id="production-package-slip-section-delivery-details-sittings" attrs={{ label: true }}>
                <DetailRow label="Sittings:" value={order.deliveryDetails.sittings ?? "-"} />
            </LocalizedStrict>
        </Stack>
    )
}
